<template>
  <div class="home">
    <router-view/>
    <!-- 底部导航的Placeholder -->
    <div class='app__tabbar-placeholder' safe-area-inset-bottom/>
    <!-- 底部Tab -->
    <van-tabbar route active-color='#17161c'>
      <van-tabbar-item v-if="isHighLevel" to="/simple-home" icon="wap-home">首页</van-tabbar-item>
      <van-tabbar-item v-if="isLowLevel" to='/home' icon='wap-home'>首页</van-tabbar-item>
      <van-tabbar-item v-if="isStarbucks" to='/starbucks-home' icon='wap-home'>首页</van-tabbar-item> 
      <van-tabbar-item to='/me' icon='manager'>我</van-tabbar-item>
    </van-tabbar>
  </div>
</template>

<script>
// @ is an alias to /src
import {Tabbar, TabbarItem,  TreeSelect} from 'vant';

export default {
  name: 'TabLayout',
  // 局部注册组件
  components: {
    [Tabbar.name]: Tabbar,
    [TabbarItem.name]: TabbarItem,
    [TreeSelect.name]: TreeSelect 
  },
  data() {
    return {
      activeTab: 0,
      icon: {
        active: 'https://img.yzcdn.cn/vant/user-active.png',
        inactive: 'https://img.yzcdn.cn/vant/user-inactive.png',
      },
    };
  },
  computed: {
    isHighLevel() {
      return this.$cookies.get("App-Level") === 'PLATFORM_HIGH';
    },
    isLowLevel() {
      return this.$cookies.get("App-Level") === 'THIRD_LOW'; 
    },
    isStarbucks() {
      return this.$cookies.get("App-Level") === 'STARBUCKS';
    }
  },
  methods: {
    onTabChange(index) {
      this.activeTab=index;
    },
    onGridClick(e) {
      console.log(e);
    }
  }
}
</script>

<style lang='less'>
  .app__tabbar-placeholder {
    height: 50px;
  }
</style>
